import React from 'react';
import NoData from '@src/components/NoData';
import { useHistory } from 'react-router-dom';
import Table from '@src/new-components/Table';
import { Skeleton } from '@mui/material';
import CopyableButton from '@src/components/CopyableButton';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { StyledChip } from '../PaymentHistory/index.style';
import { StyledList } from './index.style';

const List = ({ apps, paging, rowsPerPage, handleChangePage, loading }) => {
  const { t } = useTranslation();

  const history = useHistory();

  const handleRowClick = (rowData) => {
    if (loading) return;
    history.push(`/apps/${rowData?.id}`);
  };
  const renderStatus = (active, expiresAt) => {
    if (moment().isAfter(expiresAt))
      return (
        <div className="center-column">
          <StyledChip color="secondary">{t('expired')}</StyledChip>
        </div>
      );

    if (active)
      return (
        <div className="center-column">
          <StyledChip color="success">{t('active')}</StyledChip>
        </div>
      );

    return (
      <div className="center-column">
        <StyledChip color="error">{t('inactive')}</StyledChip>
      </div>
    );
  };

  const renderAppId = (appId) => (
    <div
      className="app-id"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        justifySelf: 'left',
        width: 'max-content',
      }}
    >
      <div title={appId}>{appId}</div>
      <CopyableButton color="#1E164ECC" content={appId} />
    </div>
  );

  const renderName = (name) => (
    <div
      style={{
        maxWidth: '177px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
      title={name}
    >
      {name}
    </div>
  );

  const columnsLoading = [
    {
      field: 'numberLoading',
      title: t('no'),
      sortable: false,
      align: 'center',
      width: 50,
    },
    {
      field: 'idLoading',
      title: t('generalInfoID'),
      sortable: false,
      align: 'left',
      width: 460,
      cellWidth: 460,
    },
    {
      field: 'nameLoading',
      title: t('appName'),
      sortable: false,
      align: 'left',
    },
    {
      field: 'statusLoading',
      title: t('status'),
      sortable: false,
      align: 'center',
    },
    {
      field: 'expiredLoading',
      title: t('expiry'),
      sortable: false,
      align: 'center',
    },
  ];

  const columns = [
    {
      field: 'number',
      title: t('no'),
      sortable: false,
      align: 'center',
      render: (row) => row.number,
      width: 50,
    },
    {
      field: 'id',
      title: t('generalInfoID'),
      sortable: false,
      align: 'left',
      render: (row) => renderAppId(row.id),
      width: 460,
      cellWidth: 460,
    },
    {
      field: 'name',
      title: t('appName'),
      sortable: false,
      align: 'left',
      render: (row) => renderName(row.name),
    },
    {
      field: 'status',
      title: t('status'),
      sortable: false,
      align: 'center',
      render: (row) => renderStatus(row.active, row.expiresAt),
    },
    {
      field: 'expired',
      title: t('expiry'),
      sortable: false,
      align: 'center',
      render: (row) => (
        <div>
          {row.expiresAt
            ? moment(row.expiresAt).format('DD/MM/YYYY')
            : t('endless')}
        </div>
      ),
    },
  ];

  return (
    <StyledList>
      <>
        {apps.length > 0 || loading ? (
          <Table
            hideFooter
            columns={loading ? columnsLoading : columns}
            headerStyle={{ borderRadius: '16px 16px 0 0' }}
            data={
              loading
                ? Array.from({ length: rowsPerPage }).map(() => ({
                    numberLoading: <Skeleton variant="text" height={20} />,
                    idLoading: <Skeleton variant="text" height={20} />,
                    nameLoading: <Skeleton variant="text" height={20} />,
                    totalRequestsLoading: (
                      <Skeleton variant="text" height={20} />
                    ),
                    statusLoading: <Skeleton variant="text" height={20} />,
                    expiredLoading: <Skeleton variant="text" height={20} />,
                  }))
                : apps?.map((item, index) => ({
                    ...item,
                    number: paging.page * rowsPerPage + index + 1,
                  }))
            }
            page={paging.page}
            total={paging.total}
            rowsPerPage={rowsPerPage}
            onChangePage={handleChangePage}
            onRowClick={handleRowClick}
            rowsPerPageOptions={[5, 25, 50]}
            styleFooter={{
              padding: '16px 16px 16px 0px',
              height: 'auto',
            }}
            showNumber={false}
          />
        ) : (
          <NoData />
        )}
      </>
    </StyledList>
  );
};

export default List;
